import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk'
import FloorIcon from '@material-ui/icons/Business'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import FlashOnIcon from '@material-ui/icons/FlashOn'
import FavoriteIcon from '@material-ui/icons/Favorite'
import HotelIcon from '@material-ui/icons/Hotel'
import WhatshotIcon from '@material-ui/icons/Whatshot'
import ShowChartIcon from '@material-ui/icons/ShowChart'
import AppShell from './components/layout/AppShell'
import PageCard from './components/ui/PageCard'
import Activities from './fitbitDashboard/Activities'
import Heart from './fitbitDashboard/Heart'
import Sleep from './fitbitDashboard/Sleep'
import COPD from './fitbitDashboard/COPD'

class FitbitDashboard extends React.Component {
  state = {
    group: {},
  }

  async getGroupData() {
    const uniqid = this.props.match.params.uniqid
    try {
      const result = await fetch(`/api/getGroupData?uniqid=${uniqid}`, {
        mode: 'cors',
        method: 'GET',
      })
      const data = await result.json()
      if (data.success) {
        this.setState({ group: data.data })
      } else {
        this.props.history.push('/groups')
      }
    } catch (err) {
      this.props.history.push('/groups')
    }
  }

  componentDidMount() {
    this.getGroupData()
  }

  buildSecondaryNav() {
    const { match, location } = this.props
    const items = [
      { key: 'steps', label: '走路', path: 'steps', icon: <DirectionsWalkIcon /> },
      { key: 'floors', label: '上樓', path: 'floors', icon: <FloorIcon /> },
      { key: 'distance', label: '距離', path: 'distance', icon: <LocationOnIcon /> },
      { key: 'calories', label: '卡路里', path: 'calories', icon: <FlashOnIcon /> },
      { key: 'heart', label: '心率', path: 'heart', icon: <FavoriteIcon /> },
      { key: 'sleep', label: '睡眠', path: 'sleep', icon: <HotelIcon /> },
      { key: 'temperature', label: '溫度', path: 'temperature', icon: <WhatshotIcon /> },
      { key: 'copd', label: 'COPD', path: 'copd', icon: <ShowChartIcon /> },
    ]
    return items.map((item) => ({
      ...item,
      to: `${match.url}/${item.path}`,
      active: location.pathname.includes(`/${item.path}`),
    }))
  }

  render() {
    const { match } = this.props
    const uniqid = match.params.uniqid

    return (
      <AppShell
        uniqid={uniqid}
        title={`Fitbit · ${this.state.group.name || ''}`}
        subtitle={this.state.group.description}
        secondaryNav={this.buildSecondaryNav()}
      >
        <PageCard>
          <Route
            path={`${match.url}/steps`}
            render={() => (
              <Activities
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="steps"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/floors`}
            render={() => (
              <Activities
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="floors"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/distance`}
            render={() => (
              <Activities
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="distance"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/calories`}
            render={() => (
              <Activities
                group_name={this.state.group.name}
                search={this.props.location.search}
                resource="calories"
                uniqid={uniqid}
              />
            )}
          />
          <Route
            path={`${match.url}/heart`}
            render={() => (
              <Heart search={this.props.location.search} resource="heart" uniqid={uniqid} />
            )}
          />
          <Route
            path={`${match.url}/sleep`}
            render={() => (
              <Sleep search={this.props.location.search} resource="sleep" uniqid={uniqid} />
            )}
          />
          <Route
            path={`${match.url}/temperature`}
            render={() => (
              <Sleep search={this.props.location.search} resource="temperature" uniqid={uniqid} />
            )}
          />
          <Route
            path={`${match.url}/copd`}
            render={() => (
              <COPD search={this.props.location.search} resource="AECOPD" uniqid={uniqid} />
            )}
          />
        </PageCard>
      </AppShell>
    )
  }
}

FitbitDashboard.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default FitbitDashboard
